<div class="empty-state-wrapper">
  <div class="image-wrapper">
    <img [src]="'e-commerce-stores/e-com-store-empty-state.svg' | assetsPath | async" />
  </div>
  <div class="title" data-lokalise data-key="txt_product_templates_list_empty_state_title"></div>
  <div class="description" data-lokalise data-key="txt_product_templates_list_empty_state_description"></div>
  <div class="action-button-wrapper">
    <button
      class="ui primary button"
      (click)="onCreateTemplateButtonClick()"
      data-lokalise
      data-key="txt_create_template"
    ></button>
  </div>
</div>
